<template>
    <div class="categ_info" v-if="obj_to_null(this.item)">
        <info_field f_uniq="ct" f_type="title" @update_categ="change_atr" :is_disabled=false :f_title="__t('NAME')" :f_val="cur_item.title"></info_field>

        <div class="form-group mt-2">
            <label class="form-label" for="organization">
                {{__t("GROUP_ID")}}
            </label>

            <div class="" v-if="groups.length > 0">
                <v-select
                      v-model="cur_item.group_id"
                          class="imc_reasons"
                          label="title"
                          :options="this.groups"
                           :reduce="item => item.id"
                          :filterable="false"
                >
                    <template slot="no-options">
                        {{__t("CHOICE_ORG")}}
                    </template>

                    <template slot="option" slot-scope="option">
                        <div class="d-center">
                            <div>
                                {{ option.title }}
                                <span class="small badge border border-info  text-info mr-1">
                                    {{option.group_type}}
                                </span>
                            </div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>

        <info_field f_uniq="ct_al" f_type="alias"  @update_categ="change_atr" :f_title="__t('ALIAS')" :f_val="cur_item.alias"></info_field>
        <div class="form-group mt-2">
            <label class="form-label" for="intro_html">
                {{ __t('INTRO_ARTICLE_HTML') }}
            </label>

            <div class="input-group flex-nowrap d-block">
                <vue-editor :editor-toolbar="editor_rules"  v-model="item.description"></vue-editor>
            </div>
        </div>



    </div>
</template>

<script>
import Info_field from "../../../../../sys/info_field";
import { VueEditor } from "vue2-editor";
import vSelect from 'vue-select';
export default {
    name: "pwa_article_info",
    components : {Info_field,VueEditor,vSelect},
    props : {
        item : {
            type : Object
        }
    },

    data() {
        return {
            cur_item : this.item,
            is_load: false,
            editor_rules :[
                ["bold", "italic", "underline","link"],
                [{ align: "center" }, { align: "right" },{ align: "justify" }],
                [{ list: "ordered" }, { list: "bullet" },{ list: "check" }],
            ],
            groups : [],
        }
    },

    created() {
        this.load_groups();
    },

    methods :  {

        async load_groups() {
            this.groups = [];
            this.is_load = true;

            await api.get('/internal/v1/catalog/pwa/news/groups').then(({data}) => {
                this.is_load = false;
                if (data.status === "operation_success") {
                    this.groups = data.data;
                }
            }).catch(({response}) => {
                this.is_load = false;
                this.groups = [];
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });

        },

        change_atr(atr_name,atr_val) {

            this.$emit('on_article_change',{
                "type"      : atr_name,
                "value"     : atr_val,
            })
        }
    },
}
</script>



<style scoped>

</style>
